import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=4a71916c&scoped=true&"
import script from "./Titlebar.vue?vue&type=script&lang=js&"
export * from "./Titlebar.vue?vue&type=script&lang=js&"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=4a71916c&scoped=true&lang=css&"
import style1 from "./Titlebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71916c",
  null
  
)

export default component.exports